import { VariantProps } from 'cva';

import { cva } from '../cva';

export const tooltipVariants = cva({
    base: [
        'px-sm py-xs pointer-events-none z-9 max-w-xs rounded-xl shadow-xl transition',
        'data-[closed]:opacity-0',
        'data-[closed]:data-[side=top]:translate-y-1',
        'data-[closed]:data-[side=bottom]:-translate-y-1',
    ],
    variants: {
        color: {
            light: 'text-gray bg-white',
            dark: 'bg-gray text-white',
        },
    },
    defaultVariants: {
        color: 'light',
    },
});

export const arrowVariants = cva({
    variants: {
        color: {
            light: 'fill-white',
            dark: 'fill-gray',
        },
    },
    defaultVariants: {
        color: 'light',
    },
});

export type TooltipVariantProps = VariantProps<typeof tooltipVariants>;
